<div id="content-section">
  <div id="content-main" style="margin-right: 420px">
    <div id="content-sidebar" class="px-0" style="width: 400px; position: fixed; right: 20px">
      <div class="px-3">
        <button (click)="newAutoTodoRule()" type="button" class="btn btn-primary btn-sm" style="width: 100%">
          <i class="fas fa-plus-circle"></i>
          &nbsp;New Auto Todo Rule
        </button>
        <hr style="margin-top: 5px; margin-bottom: 5px" />
      </div>
      <h5 class="pt-1 px-3 pb-2">
        <div class="pull-right float-right">
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearSearch()">Clear</button>
        </div>
        <span>
          Search&nbsp;&nbsp;
          <a href="javascript: void(0)" title="Search" style="cursor: pointer" (click)="loading ? '' : search()"><i *ngIf="!loading" class="fas fa-arrow-circle-right"></i><i *ngIf="loading" class="fas fa-spinner fa-pulse fa-fw"></i></a>
        </span>
      </h5>
      <div class="px-3 text-center">
        <div class="float-right">
          <app-badge badgeType="primary">
            Found {{ count }}
          </app-badge>
        </div>
        <pagination name='search_params_page' ngDefaultControl [boundaryLinks]="true" [itemsPerPage]="searchParams.per_page" [maxSize]="3" (pageChanged)="search($event)" [totalItems]="count" [(ngModel)]="searchParams.page" class="pagination-sm" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;" lastText="&raquo;"></pagination>
      </div>
      <div class="clearfix"></div>
      <hr class="my-1 mx-3" />
      <div id="search-form" class="px-3 py-2" style="overflow-y: scroll; border-bottom: 1px solid #ccc">
        <div class="form-group">
          <label>Matter</label>
          <app-matter-search #sidebar_matter_search (matter_id)="searchParams.matter_id = $event" (clearMatter)="searchParams.matter_id = null"></app-matter-search>
        </div>
        <div class="form-group">
          <label>Document Type</label>
          <app-document-type-search #sidebar_document_type_search (document_type_id)="searchParams.document_type_id = $event" (clearDocumentType)="searchParams.document_type_id = null"></app-document-type-search>
        </div>
        <div class="form-group text-center">
          <button type="button" class="btn btn-primary btn-block" [disabled]="loading" (click)="search()">
            {{ loading ? 'Searching' : 'Search' }}<span *ngIf="loading">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
          </button>
        </div>
      </div>
    </div>
    <div id="content-inner" style="padding: 10px 20px 10px 20px">
      <div class="container-fluid container-shadow py-3 px-3">
        <div class="row" *ngIf="loading">
          <div class="col">
            <div class="m-5 p-5 text-center">
              <i class="fas fa-spinner fa-fw fa-pulse fa-5x"></i>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="!loading">
          <div class="col pt-3">
            <h3>Auto Todo Rules</h3>
            <p class="text-muted">These rules allow documents of a certain type to automatically create a task with reminder on their calendar when the document is released as a <a target="_blank" href="/scan">scan</a>.</p>
            <br />
            <table class="table">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Scope</th>
                  <th>Document Type(s)</th>
                  <th>Days After</th>
                  <th>Subject</th>
                  <th>Message</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let autoTodoRule of autoTodoRules">
                  <td>
                    <a title="Edit" [routerLink]="'/auto_todo_rules/' + autoTodoRule.id + '/edit'"> <i class="fas fa-pencil-alt"></i>&nbsp;{{ autoTodoRule.id }} </a>
                  </td>
                  <td>
                    <a *ngIf="autoTodoRule.matter_id" target="_blank" [routerLink]="'/matters/' + autoTodoRule.matter_id">{{ autoTodoRule.matter_full_name }}</a>
                    <h5>
                      <app-badge badgeType="secondary" *ngIf="!autoTodoRule.matter_id">
                        Global
                      </app-badge>
                    </h5>
                  </td>
                  <td>{{ autoTodoRule.document_types_str }}</td>
                  <td>{{ autoTodoRule.days_after }}</td>
                  <td>{{ autoTodoRule.subject }}</td>
                  <td>{{ autoTodoRule.message }}</td>
                  <td>
                    <a title="Delete" class="text-danger" href="javascript: void(0)" (click)="deleteAutoTodoRule(autoTodoRule)">
                      <i class="fas fa-trash"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
